import React from 'react';
import { connect } from 'react-redux';
import classnames from 'classnames';
import { isSantander } from '../common/logica';
import ModalSintillo from '../mensajes-tooltips/mensajes-tooltips.cmpt';

import {
  descargarDocumento,
  descargarCertificado,
  descargarTarjetas,
  descargarCondiciones,
  descargarRCO,
  descargarRCOv2,
  descargarCertificadoEco,
  descargarRcUsa,
} from './polizas.act';
import { getClientInfo, getInfo } from '../movil/polizas/pagoPorKilometro.act';
import { obtenerSumaDentalia, PermisosAsistenciaDental } from './dentalia.act';
import MulticanalAcciones from '../gnp-multicanal/multicanalAcciones.cpmt';

const mapState = (state) => {
  return {
    poliza: state.polizas.poliza,
    polizasCargadas: state.polizas.polizasCargadas,
    clienteunico: state.global.uid,
    pagoPorKilometro: state.polizas.pagoPorKilometro,
    detallePagoPorKilometro: state.polizas.detallePagoPorKilometro,
    dispositivo: state.global.dispositivo,
    BeneficiosDentalia: state.polizas.BeneficiosDentalia,
    TratamientoDentalia: state.polizas.TratamientoDentalia,
    //SumaDentalia:state.polizas.SumaDentalia,
    PermisoDentalia: state.polizas.PermisoDentalia,
  };
};


const mapDispatch = (dispatch) => {
  return {
    loader: (show) => {
      dispatch({ type: 'LOADER', show: show });
    },
    descargarDocumento: (sDocumento, sPoliza, sVersion) => {
      dispatch(descargarDocumento(sDocumento, sPoliza, sVersion));
    },
    descargarCertificado: (sPoliza, sCertificado) => {
      dispatch(descargarCertificado(sPoliza, sCertificado));
    },
    descargarCertificadoEco: (certificado, numPoliza) => {
      dispatch(descargarCertificadoEco(certificado, numPoliza, false));
    },
    descargarTarjetas: (sClienteUnico, sPoliza, sVersion, sProductos) => {
      dispatch(descargarTarjetas(sClienteUnico, sPoliza, sVersion, sProductos));
    },
    descargarCondiciones: (oPoliza) => {
      dispatch(descargarCondiciones(oPoliza));
    },
    descargarRCO: (sPoliza) => {
      dispatch(descargarRCO(sPoliza));
    },
    descargarRCOv2: (sPoliza, sVersion) => {
      dispatch(descargarRCOv2(sPoliza, sVersion));
    },
    descargarRcUsa: (poliza) => {
      dispatch(descargarRcUsa(poliza));
    },
    getClientInfo: (poliza, version) => {
      return getClientInfo(poliza, version);
    },
    setDetallePagoPorKilometro: (data) => {
      dispatch({
        type: 'SET_PXK_DETAIL',
        detallePagoPorKilometro: data,
      });
    },
    tagManager: (oDataTagManager) => {
      dispatch(oDataTagManager);
    },
    /*	obtenerSumaDentalia : (sumaPoliza)=>{
      dispatch(obtenerSumaDentalia(sumaPoliza));
    },*/
    PermisosAsistenciaDental: (PermisoProductivo, PermisoComercial) => {
      dispatch(PermisosAsistenciaDental(PermisoProductivo, PermisoComercial));
    },
  };
};

class DescargasPoliza extends React.Component {
  state = {
    mostrarPagoPorKilometro: 'none',
    pagoPorKilometro: 'none',
  };

  onTrigger = (event) => {
    console.log(event);
    this.props.parentCallback(event);
    // event.preventDefault();
  };

  seccionVisible = (sTipo, sNombre) => {
    let bCondiciones = false;
    if (this.props.poliza.links) {
      this.props.poliza.links.map((item) => {
        if (item.tipo == sTipo && item.nombre == sNombre) {
          bCondiciones = true;
        }
      });
    }

    if (
      sNombre == 'poliza' &&
      sTipo == 'link' &&
      (this.props.poliza.generales.cveSistema == 'AZUL' ||
        this.props.poliza.generales.cveSistema == 'ECO')
    ) {
      bCondiciones =
        this.props.poliza.asegurados.filter(
          (asegurado) => asegurado.banderaTitular == 1
        ).length > 0;
    }

    return bCondiciones;
  };

  descargar = (sDocumento) => {
    if (
      this.props.poliza.generales.cveSistema == 'AZUL' &&
      sDocumento == 'poliza'
    ) {
      let asegurado = this.props.poliza.asegurados.filter(
        (aseg) => aseg.banderaTitular == 1
      );
      let certificado = '';
      if (asegurado.length > 0) {
        certificado = asegurado[0].certificado;
      } else {
        certificado = this.props.poliza.asegurados[0].certificado;
      }
      this.props.descargarCertificado(
        this.props.poliza.generales.numPoliza,
        certificado
      );
    } else if (
      this.props.poliza.generales.cveSistema == 'ECO' &&
      sDocumento == 'poliza'
    ) {
      console.log(' ===> SISTEMA ECO Y ES PÓLIZA <=== ');
      let asegurado = this.props.poliza.asegurados.filter(
        (aseg) => aseg.banderaTitular == 1
      );
      let certificado = '';
      if (asegurado.length > 0) {
        certificado = asegurado[0].certificado;
      } else {
        certificado = this.props.poliza.asegurados[0].certificado;
      }
      console.log(
        ' ===> polizaSeleccionada: ',
        this.props.poliza.generales.numPoliza
      );
      console.log(' ===> certificado: ', certificado);
      this.props.descargarCertificadoEco(
        certificado,
        this.props.poliza.generales.numPoliza
      );
    } else if (sDocumento == 'rco') {
      this.props.descargarRCOv2(
        this.props.poliza.generales.numPoliza,
        this.props.poliza.generales.numVersion
      );
    } else if (
      sDocumento == 'condicionesgenerales' &&
      parseInt(this.props.poliza.generales.cveClasificacionSeguro) > 4
    ) {
      this.props.descargarCondiciones(this.props.poliza.generales);
    } else if (
      sDocumento == 'condicionesgenerales' &&
      this.props.poliza.generales.cveProdTecnico === 'G0334SEGMA' &&
      ( this.props.poliza.generales.cveProdComercial === '00003' 
       ||  this.props.poliza.generales.cveProdComercial === '00004')
    ) {
      this.props.descargarCondiciones(this.props.poliza.generales);
    } else if (sDocumento == 'tarjetas') {
      this.onTrigger('test');
      let dispositivo = `portal soy cliente / ${this.props.clienteunico} / Cliente`;
      this.props.tagManager({
        dispositivo: dispositivo,
        type: 'VER_TARJETA',
      });
    } else if (sDocumento == 'polizarcusa') {
      this.props.descargarRcUsa(this.props.poliza);
    } else {
      this.props.descargarDocumento(
        sDocumento,
        this.props.poliza.generales.numPoliza,
        this.props.poliza.generales.numVersion
      );
    }
  };

  showPago = () => {
    if (
      this.props.polizasCargadas &&
      !(
        this.props.poliza.generales.cveProdComercial == '00012' &&
        this.props.poliza.generales.cveProdTecnico == 'A2400FLOT'
      ) && // AUTO MAS
      !(
        this.props.poliza.generales.cveProdComercial == '00002' &&
        this.props.poliza.generales.cveProdTecnico == 'V1011PFLVM'
      ) && // VIDA MAS
      !(
        this.props.poliza.generales.cveProdComercial == '00003' &&
        this.props.poliza.generales.cveProdTecnico == 'V1011PFLVM'
      ) // VIDA MAS INCREMENTO
    ) {
      this.props.showPago();
    }
  };

  componentDidMount() {
    this.props
      .getClientInfo(
        this.props.poliza.generales.numPoliza,
        this.props.poliza.generales.numVersion
      )
      .then((response) => {
        console.log('FechaCDM', this.props.poliza.generales.fchVigenciaInicial);

        // let currentDate = moment();
        // let startDate = moment(this.props.poliza.generales.fchVigenciaInicial, 'DD/MM/YYYY');
        // startDate = moment(startDate.add(14, 'days').format('DD/MM/YYYY'), 'DD/MM/YYYY');
        // let nowStartDateDaysDifference = (startDate.diff(moment(), 'days') <= 14) ? true : false;

        this.props.setDetallePagoPorKilometro(response);

        this.setState({
          pagoPorKilometro: response,
          mostrarPagoPorKilometro:
            response.candidate &&
              response.isStartKmCaptured &&
              !response.banRevision /*&& nowStartDateDaysDifference*/
              ? ''
              : 'none',
        });
      });
  }

  componentWillReceiveProps = (nextProps) => {
    this.setState({
      pagoPorKilometro: nextProps.detallePagoPorKilometro,
      mostrarPagoPorKilometro:
        nextProps.detallePagoPorKilometro.candidate &&
          nextProps.detallePagoPorKilometro.isStartKmCaptured &&
          !nextProps.detallePagoPorKilometro
            .banRevision /*&& nowStartDateDaysDifference*/
          ? ''
          : 'none',
    });
  };

  componentWillMount = () => {
    //this.props.obtenerSumaDentalia(this.props.poliza.generales.numPoliza);

    this.props.PermisosAsistenciaDental(
      this.props.poliza.generales.cveProdTecnico,
      this.props.poliza.generales.cveProdComercial
    );
  };

  tagEvent() {
    this.props.tagManager({
      dispositivo: this.props.dispositivo,
      type: 'EVENT_CLICK_MOSTRAR-PAGO-POR-KM',
    });
  }
  tagEventGMM() {
    this.props.tagManager({
      dispositivo: this.props.dispositivo,
      type: 'ON_ASISTENCIA_DENTAL_GMM_PORTAL',
    });
  }

  tagEventVida() {
    this.props.tagManager({
      dispositivo: this.props.dispositivo,
      type: 'ON_ASISTENCIA_DENTAL_VIDA_PORTAL',
    });
  }

  mostrarTarjetas = () => {
    try {
      const arrFchVI =
        this.props.poliza.generales.fchVigenciaInicial.split('/');
      let day = new Date();
      day.setHours(0, 0, 0, 0);
      const today = day.getTime();
      const arrFchVF = this.props.poliza.generales.fchVigenciaFinal.split('/');
      const fchVI = new Date(
        arrFchVI[2],
        Number(arrFchVI[1]) - 1,
        arrFchVI[0]
      ).getTime();
      const fchVF = new Date(
        arrFchVF[2],
        Number(arrFchVF[1]) - 1,
        arrFchVF[0]
      ).getTime();

      return (
        this.props.poliza.generales.cveRamo == 'G' &&
        this.props.poliza.generales.cveEstatus !== 'C' &&
        today >= fchVI &&
        today <= fchVF
      );
    } catch (error) {
      console.log('Error al caulcular fechas', error);
    }
  };

  mostrarPagar() {
    const { cveProdComercial, cveProdTecnico, viaNomina } = this.props.poliza.generales;
    if ((cveProdComercial === '00003' && cveProdTecnico === 'G0334SEGMA') || viaNomina) {
      return false;
    }
    return true;
  }

  muestraTooltip = (show, type?, titulo?, mensaje?) => {
    setTimeout(() => {
      this.setState({ showTooltip: show, type: type, titulo: titulo, mensaje: mensaje });
    }, 300);
  }

  cierraTooltip = e => {
    this.setState({
      showTooltip: !this.state.showTooltip
    });
  }

  verTooltip = () => {
    console.log("hola");
    this.muestraTooltip(true, 'error', 'Error', 'Esta póliza .');
  }

  render() {
    let clsPagar = classnames({
      'orange-btn': this.props.polizasCargadas,
      'orange-btn-disabled': !(
        (
          this.props.polizasCargadas &&
          !(
            this.props.poliza.generales.cveProdComercial == '00012' &&
            this.props.poliza.generales.cveProdTecnico == 'A2400FLOT'
          ) && // AUTO MAS
          !(
            this.props.poliza.generales.cveProdComercial == '00002' &&
            this.props.poliza.generales.cveProdTecnico == 'V1011PFLVM'
          ) && // VIDA MAS
          !(
            this.props.poliza.generales.cveProdComercial == '00003' &&
            this.props.poliza.generales.cveProdTecnico == 'V1011PFLVM'
          )
        ) // VIDA MAS INCREMENTO
      ),
      'pd-lr-20': true,
    });

    console.log('Mostrar', this.state.mostrarPagoPorKilometro);

    return (
      <div className="col-xs-12">
        <ModalSintillo onClose={this.cierraTooltip} titulo={this.state.titulo}
          show={this.state.showTooltip} type={this.state.type} mensaje={this.state.mensaje}>
        </ModalSintillo>
        <div className="card bl-orange">
          <div className="pad-15">
            <div className="menu-list">
              <div className="pull-right"></div>
              <ul className="clearfix row detalle-download ul-acciones">
                {this.seccionVisible('link', 'poliza') &&
                  !isSantander(this.props.poliza) && (
                    <li className="detalle-download-btn">
                      <img
                        onClick={this.descargar.bind(this, 'poliza')}
                        src={require('../img/01-descargar.svg')}
                      />
                    </li>
                  )}
                {!this.props.poliza.links && !isSantander(this.props.poliza) && (
                  <li className="detalle-download-btn">
                    <img
                      onClick={this.descargar.bind(this, 'poliza')}
                      src={require('../img/01-descargar.svg')}
                    />
                  </li>
                )}
                { (  this.props.poliza.generales.cveProdComercial === '00003'
                  || this.props.poliza.generales.cveProdComercial === "00004" )
                &&
                  this.props.poliza.generales.cveProdTecnico ==
                  'G0334SEGMA' && (
                    <li className="detalle-download-btn">
                      <img
                        onClick={this.descargar.bind(
                          this,
                          'condicionesgenerales'
                        )}
                        src={require('../img/descargar-movil.svg')}
                      />
                    </li>
                  )}
                {this.props.poliza.generales.cveRamo == 'V' && (
                  <li className="detalle-download-btn">
                    <img
                      data-toggle="modal"
                      data-target="#modal-edocuenta"
                      src={require('../img/06-estados.svg')}
                    />
                  </li>
                )}
                {this.seccionVisible('link', 'recibos') && (
                  <li className="detalle-download-btn">
                    <img
                      data-toggle="modal"
                      data-target="#modal-recibos"
                      src={require('../img/03-recibo.svg')}
                    />
                  </li>
                )}
                {this.seccionVisible('link', 'facturas') && (
                  <li className="detalle-download-btn">
                    <img
                      data-toggle="modal"
                      data-target="#modal-facturas"
                      src={require('../img/04-facturas.svg')}
                    />
                  </li>
                )}
                {this.props.poliza.generales.cveRamo == 'A' && (
                  <li className="detalle-download-btn">
                    <img
                      onClick={this.descargar.bind(this, 'rco')}
                      src={require('../img/05-rc.svg')}
                    />
                  </li>
                )}
                {this.props.poliza.generales.cveRamo == 'A' && (
                  <li className="detalle-download-btn">
                    <img
                      onClick={this.descargar.bind(this, 'polizarcusa')}
                      src={require('../img/icon_rc_EUA_25.svg')}
                    />
                  </li>
                )}

                {this.mostrarTarjetas() && (
                  <li className="detalle-download-btn">
                    <img
                      style={{ 'min-height': '78px' }}
                      onClick={this.descargar.bind(this, 'tarjetas')}
                      src={require('../img/tarjeta-gmm.svg')}
                    />
                  </li>
                )}
                {this.props.poliza.generales.cveRamo == 'G' &&
                  ((this.props.poliza.generales.cveProdTecnico == 'G0334GMMII' &&
                    (this.props.poliza.generales.cveProdComercial == '00001' ||
                      this.props.poliza.generales.cveProdComercial == '00002' ||
                      this.props.poliza.generales.cveProdComercial == '00008' ||
                      this.props.poliza.generales.cveProdComercial == '00009' ||
                      this.props.poliza.generales.cveProdComercial == '00010')) ||
                    (this.props.poliza.generales.cveProdTecnico == 'G0334GMMIN' &&
                      (this.props.poliza.generales.cveProdComercial == '00001' ||
                        this.props.poliza.generales.cveProdComercial == '00003' ||
                        this.props.poliza.generales.cveProdComercial == '00005' ||
                        this.props.poliza.generales.cveProdComercial ==
                        '00007')) ||
                    (this.props.poliza.generales.cveProdComercial ==
                      'G0334SEGMA' &&
                      this.props.poliza.generales.cveProdComercial == '00001') ||
                    this.props.poliza.generales.cveProdComercial == '00003') ? (
                  <li className="detalle-download-btn">
                    <img
                      data-toggle="modal"
                      onClick={this.tagEventGMM.bind(this)}
                      data-target="#modal-dentalia"
                      src={require('../img/asistenciaDental_14p.svg')}
                    />
                  </li>
                ) : null}
                {/*
								this.props.poliza.generales.cveRamo === "V" &&
								(this.props.SumaDentalia.numeroPoliza === this.props.poliza.generales.numPoliza) ?
								<li className="detalle-download-btn">
									<img data-toggle="modal" onClick={this.tagEventVida.bind(this)} data-target="#modal-dentalia" src={ require("../img/asistenciaDental_14p.svg") } />
								</li>
								:null
							*/}

                <li
                  className="detalle-download-btn"
                  style={{ display: this.state.mostrarPagoPorKilometro }}
                >
                  <img
                    style={{ objectFit: 'contain' }}
                    onClick={this.tagEvent.bind(this)}
                    data-toggle="modal"
                    data-target="#modal-ppkilometro"
                    src={require('../img/smart-trip-bk.png')}
                  />
                </li>

                {this.props.poliza.generales.cveRamo === 'D' && (
                  <MulticanalAcciones
                    isMascotasPoliza={this.props.isMascotasPoliza}
                  />
                )}
              </ul>
              {this.seccionVisible("servicio", "pagar") && this.props.poliza.cobranza && this.props.poliza.cobranza.registros && this.props.poliza.cobranza.registros.length > 0 && (
                <div
                  className="pagar-button-li"
                  style={{
                    'pointer-events': this.props.polizasCargadas
                      ? 'auto'
                      : 'none',
                  }}
                >
                  {this.mostrarPagar() ? (
                    <a
                      onClick={this.showPago}
                      className={clsPagar}
                      style={{ margin: '10px 0' }}
                    >
                      Pagar recibo
                    </a>
                  ) : null}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(mapState, mapDispatch)(DescargasPoliza);



// WEBPACK FOOTER //
// ./src/home/descargas.cmpt.js